import merge from 'deepmerge';
import { createSelector } from 'reselect';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Utils
import selectorWithoutMemoize from '@tekion/tekion-base/utils/selectorWithoutMemoize';

/**
 * This function is made to provide default values to parent and the current tr props.
 * As the deepmerge library does not handle the default values as per the code.
 */
var mergeTrProps = function mergeTrProps() {
  var parentTrProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var trProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  return merge(parentTrProps, trProps);
};
export var makeGetTrProps = function makeGetTrProps() {
  var parentGetTrProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
  var getTrProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noop;
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    var parentTrProps = parentGetTrProps.apply(void 0, params) || {};
    var trProps = getTrProps.apply(void 0, params.concat([parentTrProps]));
    return mergeTrProps(parentTrProps, trProps);
  };
};